import './styles.scss'

export function LinearProgress (props) {
  return (
    <div
      className='progress'
      data-cy='progress'
      {...props}
    >
      <div className='indeterminate' />
    </div>
  )
}
